import Matrix, { EnvironmentEnum } from '@mc/matrix-main'

const matrix = new Matrix()

export const SUPPLIER_APP_DOWNLOAD_URL = {
  ios: 'https://apps.apple.com/cn/app/%E7%BE%8E%E8%8F%9C%E4%BE%9B%E5%BA%94%E5%95%86/id1494665425',
  android:
    'https://ampstore.yunshanmeicai.com/ampstore/app/downjsonp?mark=PwspIf&build_env=production'
}

export const isWechatBrowser = () =>
  matrix.environment === EnvironmentEnum.Wechat

const getAndroidDownloadUrl = () =>
  new Promise((resolve, reject) => {
    const callbackName = `supplierAppDownload${Date.now()}`
    const script = document.createElement('script')
    const separator = SUPPLIER_APP_DOWNLOAD_URL.android.includes('?') ? '&' : '?'
    const timeout = window.setTimeout(() => {
      cleanup()
      reject(new Error('下载链接请求超时'))
    }, 10000)

    const cleanup = () => {
      window.clearTimeout(timeout)
      delete window[callbackName]
      script.parentNode && script.parentNode.removeChild(script)
    }

    window[callbackName] = response => {
      cleanup()
      if (response && response.ret === 1 && response.data && response.data.url) {
        resolve(response.data.url)
        return
      }
      reject(new Error((response && response.msg) || '下载链接获取失败'))
    }

    script.async = true
    script.onerror = () => {
      cleanup()
      reject(new Error('下载链接请求失败'))
    }
    script.src = `${SUPPLIER_APP_DOWNLOAD_URL.android}${separator}callback=${callbackName}`
    document.head.appendChild(script)
  })

export const downloadSupplierApp = async () => {
  const { isIOS } = matrix
  if (isIOS) {
    window.location.href = SUPPLIER_APP_DOWNLOAD_URL.ios
    return
  }

  const url = await getAndroidDownloadUrl()
  window.location.href = url
}
